import { SvgIcon, SvgIconProps } from '@mui/material';
import './ccf-writing-icon.module.scss';

/* eslint-disable-next-line */
export interface CcfWritingIconProps extends SvgIconProps  { }

/**
 * Component display pencil icon 
 * @param props -CcfWritingIconProps
 * @returns svg Writing icon
 * @example -<CcfWritingIcon/>
 */
export function CcfWritingIcon(props: CcfWritingIconProps) {
  return (
    <SvgIcon {...props}>
      <svg xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink" width="20" height="20" viewBox="0 0 20 20">
        <defs>
          <clipPath id="clip-Tile_Writing">
            <rect width="20" height="20" />
          </clipPath>
        </defs>
        <g id="Tile_Writing" data-name="Tile Writing" clipPath="url(#clip-Tile_Writing)">
          <path id="edit" d="M15.7,2.5l1.9,2L4.5,17.5l-2.2.3.4-2.4,13-12.9Zm0-2.5a.864.864,0,0,0-.6.3L.9,14.3a.367.367,0,0,0-.1.3l-.8,5a.6.6,0,0,0,.1.4H.4l4.8-.6a.367.367,0,0,0,.3-.1l14.1-14a.972.972,0,0,0,.1-1.4L16.4.3a.908.908,0,0,0-.7-.3h0Z" transform="translate(0.025)" />
        </g>
      </svg>
    </SvgIcon>
  );
}

export default CcfWritingIcon;
